/// <reference types="@angular/localize" />

import {APP_INITIALIZER, enableProdMode, importProvidersFrom} from '@angular/core';
import {environment} from './environments/environment';
import {AppComponent} from "./app/app.component";
import {provideRouter, withEnabledBlockingInitialNavigation, withViewTransitions} from "@angular/router";
import {routes} from "./app/app.routes";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from "@angular/common/http";
import {bootstrapApplication, BrowserModule} from "@angular/platform-browser";
import {SettingsProvider} from "./app/_services/config.service";
import {OAuthModule, OAuthService, provideOAuthClient} from "angular-oauth2-oidc";
import {AuthService} from "./app/_services/auth.service";
import {provideAnimations} from "@angular/platform-browser/animations";
import {dropdownProviders} from "./app/shared/bsdropdownwrapper.module";
import {AuthInterceptor} from "./app/auth/auth.interceptor";
import {ToastrModule} from "ngx-toastr";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {DropdownModule, SidebarModule} from "@coreui/angular";
import '@coreui/coreui-pro/js/dist/dropdown';
import {IconSetService} from "@coreui/icons-angular";
import {
  cilSpeedometer,
  cilSpreadsheet,
  cilPhone,
  cilUser,
  cilFile,
  cilList,
  cilWarning,
  cilBritishPound,
  cilGroup,
  cilPlaylistAdd,
  cilBug,
  cilLoopCircular
} from '@coreui/icons';
import {provideSweetAlert2} from "@sweetalert2/ngx-sweetalert2";


export function initializeAuth(
  settings: SettingsProvider,
  oauth: OAuthService,
  authService: AuthService,
  http: HttpClient
) {
  return async () => {
    await settings.loadConfig();
    await oauth.loadDiscoveryDocumentAndTryLogin();
    // ✅ Signal that auth init is done regardless of login state
    authService.signalAuthInitComplete();
  };
}



if (environment.production) {
  enableProdMode();
}


// ⭐ BOOTSTRAP APPLICATION
bootstrapApplication(AppComponent, {
  providers: [
    provideSweetAlert2(),
    provideAnimationsAsync(),

    importProvidersFrom(
      SidebarModule,
      DropdownModule,
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: ['https://localhost:44322/api', '/api', 'https://fitrite365.com/api'],
          sendAccessToken: true
        },
      }),
      ToastrModule.forRoot({
        positionClass: 'toast-bottom-right',
        timeOut: 3000,
        preventDuplicates: true,
      }),
      BrowserModule
    ),

    provideHttpClient(withInterceptorsFromDi()),
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},

    provideRouter(
      routes,
      withViewTransitions({ skipInitialTransition: true })
    ),

    {
      provide: IconSetService,
      useFactory: () => {
        const iconSet = new IconSetService();
        iconSet.icons = {
          cilSpeedometer,
          cilSpreadsheet,
          cilPhone,
          cilUser,
          cilFile,
          cilList,
          cilWarning,
          cilBritishPound,
          cilGroup,
          cilPlaylistAdd,
          cilBug,
          cilLoopCircular
        };
        return iconSet;
      },
    },

    provideAnimations(),
    provideOAuthClient(),

    // ⭐ AuthService is safe to construct AFTER OAuthService is configured
    AuthService,

    // ⭐ CRITICAL: APP_INITIALIZER runs BEFORE routing
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      deps: [SettingsProvider, OAuthService, AuthService, HttpClient],
      multi: true
    },

    OAuthService,
    dropdownProviders
  ]
}).catch(err => console.error(err));
